import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { unAuthService } from "Service/Axios";
import { campaignTrackUrl } from "Constant/api";

export const useCaptureUTM = () => {
  const { t } = useTranslation();
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const utmSource = query.get("utm_source");
  const utmMedium = query.get("utm_medium");
  const utmCampaign = query.get("utm_campaign");
  const utmContent = query.get("utm-content");
  const campaignId = query.get("campaign_id");

  useEffect(() => {
    if (utmSource || utmMedium || utmCampaign || utmContent || campaignId) {
      const sendUTM = async () => {
        try {
          const utmData = {};
          if (utmSource) {
            utmData.utm_source = utmSource;
          }
          if (utmMedium) {
            utmData.utm_medium = utmMedium;
          }
          if (utmCampaign) {
            utmData.utm_campaign = utmCampaign;
          }
          if (campaignId) {
            utmData.campaign_id = campaignId;
          }
          if (utmContent) {
            utmData.utm_content = utmContent;
          }

          await unAuthService(campaignTrackUrl, "POST", utmData);
        } catch {
          toast.error(
            t("common.messages.notification.failed.somethingWentWrong")
          );
        }
      };

      sendUTM();
    }
  }, [utmSource, utmMedium, utmCampaign, utmContent, campaignId]);
};
